import { useState } from 'react';
import { useNavigate } from 'react-router';
import imgLogowithlcon1 from '../../assets/logo-cherry-color.webp';
import { ConfirmModal } from './ConfirmModal';
import { clearAuth } from '../../lib/auth';
import { logout as proLogoutApi } from '../../lib/professional-api';
import { useAuth } from '../../lib/use-auth';
import { toast } from '../../lib/toast';

// Back navigation lives on the page (e.g. the wizard's in-page Back),
// never in this header — only the logo and a Logout (when signed in).
export function OnboardingHeader() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [loggingOut, setLoggingOut] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleConfirmLogout = async () => {
    if (loggingOut) return;
    setLoggingOut(true);
    try {
      await proLogoutApi();
    } catch {
      // Network / 4xx — still clear local auth so the user isn't stuck
      // mid-onboarding.
    } finally {
      clearAuth();
      setLoggingOut(false);
      setConfirmOpen(false);
      toast.success('Logged out.');
      navigate('/', { replace: true });
    }
  };

  return (
    <header className="border-b border-[#eee] bg-white sticky top-0 z-50">
      <div className="max-w-[1140px] mx-auto w-full flex items-center justify-between px-4 py-3">
        {/* Logo - Left */}
        <div className="w-[100px] md:w-[120px] cursor-pointer" onClick={() => navigate('/')}>
          <img src={imgLogowithlcon1} alt="Cherry Picked" className="w-full h-auto object-contain" />
        </div>

        {/* Right cluster — Logout only (when authed). */}
        <div className="flex items-center gap-2">
          {isAuthenticated ? (
            <button
              type="button"
              onClick={() => setConfirmOpen(true)}
              disabled={loggingOut}
              className="px-4 md:px-6 h-[44px] bg-[#f4f4f4] text-[#3a3335] font-['DM_Sans',sans-serif] font-bold text-sm rounded-lg hover:bg-[#eee] transition-colors disabled:opacity-60"
            >
              {loggingOut ? 'Logging out…' : 'Logout'}
            </button>
          ) : null}
        </div>
      </div>

      <ConfirmModal
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={handleConfirmLogout}
        title="Log out?"
        message="You'll need to sign in again to come back to your onboarding."
        confirmLabel="Log out"
        cancelLabel="Stay signed in"
        confirming={loggingOut}
      />
    </header>
  );
}
